import storage from "@/utils/storage";
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import plugins from "./plugins";

import ElementUI from "element-ui";
import "@/assets/styles/element-variables.scss";
import "@/assets/styles/index.scss";
import "@/assets/styles/ruoyi.scss";

import { parseTime, resetForm } from "@/utils";
function initVueApp() {
    Vue.prototype.parseTime = parseTime;
    Vue.prototype.resetForm = resetForm;

    Vue.prototype.storage = storage;

    Vue.use(ElementUI);
    Vue.use(plugins);

    Vue.config.productionTip = false;

    new Vue({
        router,
        store,
        el: "#app",
        render: (h) => h(App)
    }).$mount("#app");
}

if (!sessionStorage.getItem("client-userInfo") || !sessionStorage.getItem("Authorization")) {
    sessionStorage.removeItem("client-userInfo");
    sessionStorage.removeItem("Authorization");
    localStorage.clear();
    window.location.href = process.env.VUE_APP_KW_AUTH_BASE_URL + "enterpriseAuth/goLogin?systemType=tscyyClient";
} else {
    initVueApp();
}
//initVueApp();